import { applyMiddleware, compose, createStore } from 'redux'
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from '../index.Dux'
import thunk from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'
import { rootSaga } from '@modules/app.dux'

// create middlewares
let middleware = []
let composeEnhancers = compose
let reducer = rootReducer

middleware = [thunk, ...middleware]

// add persistor
let persistConfig = { key: 'root', storage, blacklist: ['qos'] }
// if (process.env.NODE_ENV !== 'production') persistConfig = {key: 'root', storage, blacklist: ['']}; // TODO: find a better way and decide what to persist
reducer = persistReducer(persistConfig, reducer)

if (process.env.NODE_ENV !== 'production') {
  const devMiddleware = [reduxImmutableStateInvariant()]
  middleware = [...middleware, ...devMiddleware]
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose // add support for Redux dev tools
}

const sagaMiddleware = createSagaMiddleware()

let store = createStore(reducer, {}, composeEnhancers(applyMiddleware(sagaMiddleware), applyMiddleware(...middleware)))

// initialize saga threads
sagaMiddleware.run(rootSaga)

export default store
